import { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { postAddFlightDetails } from "../../candidateListFunctions";
import { useDispatch } from "react-redux";

export default function AddFlightDetails({
  popupState,
  setPopupState,
  candidateData,
  setCandidateListData,
}) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [finalObj, setFinalObj] = useState({});
  console.log(finalObj, "final obj");

  useEffect(() => {
    if (!finalObj.country && finalObj.candidate_id) {
      const country = candidateData.candidates.find(
        (candidate) => candidate.id === finalObj.candidate_id
      )?.nationality_name;
      setFinalObj((prevState) => ({
        ...prevState,
        country: country,
      }));
    }
  }, [finalObj]);
 
  const [instance, setInstance] = useState();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { ...finalObj };
    const response = await postAddFlightDetails({
      dispatch,
      setCandidateListData,
      setLoading,
      body,
    });
    if (response.completed) {
      setPopupState(false);
    }
  };

  const dateDDMMYYYYtoYYYYMMDD = (date) => {
    if (!date) return null;
    return String(date).split("-").reverse().join("-");
  };
  const isInvalidArrivalDate =
    new Date(dateDDMMYYYYtoYYYYMMDD(finalObj?.date_of_arrival)) <
    new Date(dateDDMMYYYYtoYYYYMMDD(finalObj?.date_of_departure));
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        popupState ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full h-auto min-h-[10rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <div className="flex justify-between items-start w-full">
          <div>
            <h1 className="text-xl font-semibold">Add Flight Details</h1>
          </div>
          <button
            className="text-md font-semibold cursor-pointer"
            onClick={() => setPopupState(false)}
            disabled={loading}
          >
            <IoMdClose size={"1.2rem"} />
          </button>
        </div>
        <form className="px-5 py-2 mt-5" onSubmit={handleSubmit}>
          <ArraySelectInput
            title="Select a Candidate"
            array={candidateData?.candidates?.filter(
              (candidate) =>
                candidate?.status == "VISA STAMPED" &&
                candidate?.candidate_file?.status == "Completed"
            )}
            objKey="candidate_id"
            labelName="candidate_id"
            setFinalObj={setFinalObj}
            required
          />
          {finalObj?.candidate_id && (
            <>
              <TextInput
                title="Flight Details"
                objKey="flight_details"
                setFinalObj={setFinalObj}
              />
              <TextInput
                title="Country"
                objKey="country"
                setFinalObj={setFinalObj}
                value={
                  candidateData.candidates.find(
                    (candidate) => candidate.id === finalObj.candidate_id
                  )?.nationality_name
                }
              />
              {/* <ArraySelectInput
                title="Nationality"
                array={candidateData?.nationality}
                objKey="country"
                objValue="name"
                setFinalObj={setFinalObj}
              /> */}
              {/* <TextInput
                title="Time of departure"
                type="time"
                objKey="time_of_departure"
                setFinalObj={setFinalObj}
              /> */}
              <div className="grid sm:grid-cols-3 gap-3">
                <div className="sm:col-span-2">
                  <TextInput
                    title="Date of departure"
                    type="date"
                    objKey="date_of_departure"
                    setFinalObj={setFinalObj}
                  />
                </div>
                <TimePicker
                  title="Time of departure"
                  objKey="time_of_departure"
                  setFinalObj={setFinalObj}
                />
              </div>

              {/* <TextInput
                title="Time of arrival"
                type="time"
                objKey="time_of_arrival"
                setFinalObj={setFinalObj}
              /> */}
              <div className="grid sm:grid-cols-3 gap-3">
                <div className="sm:col-span-2">
                  <TextInput
                    title="Date of arrival"
                    type="date"
                    objKey="date_of_arrival"
                    setFinalObj={setFinalObj}
                    description={
                      isInvalidArrivalDate &&
                      finalObj?.date_of_arrival &&
                      "Should be equal or greater than departure date"
                    }
                    min={dateDDMMYYYYtoYYYYMMDD(finalObj?.date_of_departure)}
                  />
                </div>
                <TimePicker
                  title="Time of arrival"
                  objKey="time_of_arrival"
                  setFinalObj={setFinalObj}
                />
              </div>
              <ArraySelectInput
                title="Select Sector"
                array={candidateData?.sector}
                objKey="arrival_sector_id"
                setFinalObj={setFinalObj}
                required
              />
              <TextInput
                title="Pick up to be arranged"
                objKey="pickup_to_be_arranged"
                setFinalObj={setFinalObj}
              />
              <TextInput
                title="Project In Charge"
                objKey="project_incharge"
                setFinalObj={setFinalObj}
              />
            </>
          )}

          <div className="p-2  w-full flex gap-3">
            <button
              type="button"
              className="ring-1 ring-slate-300  uppercase w-full text-xs rounded-md py-2 flex justify-center items-center gap-2"
              // disabled={loading}
              onClick={() => setPopupState(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={
                "bg-red uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2 disabled:bg-red/80 disabled:cursor-not-allowed"
              }
              disabled={loading || isInvalidArrivalDate}
            >
              Submit
              {loading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// import React from 'react';
import Select from "react-select";
import nodeinstance from "../../../../../../../../nodeInstance";

const ArraySelectInput = ({
  title,
  array,
  objKey,
  objValue = null,
  setFinalObj,
  description,
  labelName = null,
  required = false,
}) => {
  const options = array?.map((data) => ({
    value: objValue ? data[objValue] : data?.id || data,
    label: labelName ? data[labelName] : data?.name || data,
  }));

  // Custom styles for the react-select dropdown
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%", // Set width to 100%
      borderColor: state.isFocused ? "gray" : "#C0C5CC", // Set border color based on focus state
      borderBottomColor: state.isFocused ? "gray" : "#C0C5CC", // Set border color below based on focus state
      // Add your custom styles for the control element here
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "#fff", // Set background color for options
      color: "#000",
      // Add your custom styles for each option here
    }),
    // Add more styles for other elements if needed
  };

  return (
    <div className={`form-control w-full gap-[0.15rem] mb-4`}>
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <Select
        options={options}
        onChange={(selectedOption) => {
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]: selectedOption.value,
          }));
        }}
        placeholder="Select an Option"
        isSearchable={true}
        styles={customStyles} // Apply custom styles
        required={required}
        menuPosition="fixed" // Ensure menu overflows outside the container
      />
      <p className="text-xs text-blue pl-3">{description}</p>
    </div>
  );
};

const TimePicker = ({ title, objKey, setFinalObj }) => {
  const [selectedHour, setSelectedHour] = useState(0);
  const [selectedMinute, setSelectedMinute] = useState(0);

  const hours = Array.from({ length: 24 }, (_, index) => index); // Array [0, 1, 2, ..., 23]
  const minutes = Array.from({ length: 60 }, (_, index) => index); // Array [0, 1, 2, ..., 59]

  const handleHourChange = (e) => {
    const newHour = parseInt(e.target.value, 10);
    setSelectedHour(newHour);
    updateFinalObj(newHour, selectedMinute);
  };

  const handleMinuteChange = (e) => {
    const newMinute = parseInt(e.target.value, 10);
    setSelectedMinute(newMinute);
    updateFinalObj(selectedHour, newMinute);
  };

  const updateFinalObj = (hour, minute) => {
    // Set seconds to '00' by default
    const seconds = "00";
    setFinalObj((prevState) => ({
      ...prevState,
      [objKey]: `${String(hour).padStart(2, "0")}:${String(minute).padStart(
        2,
        "0"
      )}:${seconds}`,
    }));
  };

  return (
    <div className={`form-control w-full gap-[0.15rem] mb-4`}>
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <div className="grid sm:grid-cols-2 gap-2 ">
        <select
          className="select select-sm select-bordered w-full"
          // value={selectedHour}
          onChange={handleHourChange}
          required
        >
          <option value="" hidden>
            HH
          </option>
          {hours.map((hour) => (
            <option
              style={{
                // fontFamily: "fantasy",
                fontSize: "1rem",
                textAlign: "center",
              }}
              key={hour}
              value={hour}
            >
              {String(hour).padStart(2, "0")}
            </option>
          ))}
        </select>
        {/* <span
          style={{ fontSize: "2rem" }}
          className="text-xs justify-self-center self-center"
        >
          :
        </span> */}
        <select
          className="select select-sm select-bordered w-full"
          // value={selectedMinute}
          onChange={handleMinuteChange}
          required
        >
          <option value="" hidden>
            MM
          </option>

          {minutes.map((minute) => (
            <option
              style={{
                // fontFamily: "fantasy",
                fontSize: "1rem",
                textAlign: "center",
              }}
              key={minute}
              value={minute}
            >
              {String(minute).padStart(2, "0")}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const TextInput = ({
  title,
  type,
  objKey,
  setFinalObj,
  description,
  value,
  min = null,
}) => {
  console.log(value, "testvalue");
  return (
    <div className={`form-control w-full gap-[0.15rem] mb-4`}>
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <input
        required
        type={type || "text"}
        placeholder="Type here"
        className="input input-sm input-bordered w-full"
        defaultValue={value ? value : ""}
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]:
              type == "date"
                ? String(e.target.value).split("-").reverse().join("-")
                : type == "time"
                  ? `${String(e.target.value)}:00`
                  : String(e.target.value).toUpperCase(),
          }))
        }
        min={min}
      />
      <p className="text-xs text-red pl-1">{description}</p>
    </div>
  );
};
